<div
  class="overlay"
  lumAppLoader
  [loading]="loading"
  [classes]="'loading blur'"
></div>
<div *ngIf="stock; else empty" class="location-warehouse-quantity-entry mb-35">
  <div class="location-warehouse__header flex p-6">
    <div class="grow">
      <div class="location-warehouse__header-location">
        <div>Location:</div>
        <h1 class="mat-h2 font-bold">{{ stock?.location?.locationName }}</h1>
      </div>
      <div class="location-warehouse__header-sku">
        <div>SKU:</div>
        <h1 class="mat-h2 font-bold">
          {{ stock?.rfqStock?.rfq?.internalSku }} -
          {{ stock?.rfqStock?.rfq?.productName }}
        </h1>
      </div>
    </div>
    <div class="flex align-center">
      <h1>
        {{ stock?.onHandQuantity | number }}
      </h1>
    </div>
  </div>

  <div class="location-warehouse__content p-6">
    <div class="location-warehouse__quanity flex flex-column gap-4">
      <input
        [formControl]="quantityControl"
        type="number"
        placeholder="Enter Quantity..."
        class="lum-input"
      />
      <button class="lum-button w-100" (click)="onUpdate()">Update</button>
      <button
        class="lum-button w-100"
        [routerLink]="[
          '/warehouse-mobile-app/transfer/from',
          stock?.id,
          quantityControl?.value,
        ]"
      >
        Transfer
      </button>
    </div>
    <mat-divider class="mt-4 mb-4"></mat-divider>
    <div class="flex flex-column gap-4">
      <button
        class="lum-button lum-button--tertiary w-100"
        (click)="toggleCalculator = !toggleCalculator"
      >
        Toggle Calculator
      </button>

      <ng-container *ngIf="toggleCalculator">
        <lum-ui-virtual-calculator
          [@slideUpAnimation]
          [@rollDownAnimation]
          [value]="value"
          (valueChangeEmit)="onValueChange($event)"
        ></lum-ui-virtual-calculator>

        <button class="lum-button w-100" (click)="onSaveResults()">
          Save Results
        </button>

        <div class="flex flex-column gap-4">
          <div class="mat-h3">Saved Results</div>
          <div
            *ngFor="
              let result of savedResults;
              let i = index;
              trackBy: trackByValue
            "
            class="flex"
          >
            <div class="mat-h3 grow">{{ result }}</div>
            <div>
              <button mat-icon-button color="warn" (click)="onRemoveSavedResult(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div>
            <div class="mat-h2 font-bold">
              Total: {{ totalSavedResults | number }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #empty>
  <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
</ng-template>
